<script>
export default {
  name: 'ResourceEmpty'
}
</script>
<template>
  <div class="resourceEmpty">
    <div class="resourceEmptyTitle">
      <img src="@/assets/image/resource-no-data.png" alt="请选择本地资源上传">
      <span>请选择本地资源上传</span>
    </div>
  </div>
</template>
<style scoped lang="scss">
.resourceEmpty {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;

  .resourceEmptyTitle {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    img {
      width: 400px;
      margin-bottom: 20px;
    }

    span {
      color: #bcbcbc;
      font-size: 18px;
    }
  }
}
</style>
